export const styelOverlay = {
    pageReload: {
        width: '80%',
        maxWidth: '800px',
        borderRadius: '10px',
        margin: 'auto',
        backgroundColor: '#f6f6f6',
        color: '#000',
        padding: '20px',
        textAlign: 'center'
    },
    overlayContainer: { maxWidth: '1120px!important',
        marginTop: '5%' },
    overlayH4: { marginTop: '10px'
    },
    footerStyle: {
        width: '100%' }
};
